<template>
    <div class="me">
        <div class="m-header">
            <div class="top">
                <div class="userInfo">
                    <div class="headerImage">
                        <img class="userImg" v-lazy="user.isLogin? user.logourl:imgHeaderImg" alt="">
                        <!-- <img class="userImg" v-lazy="user.isLogin? item.headimgurl:imgHeaderImg" alt=""> -->
                    </div>
                    <div class="tip" v-if="!user.isLogin">登录后查看完整内容</div>
                    <div class="name" v-else>{{user.nickname}}</div>
                </div>
                <router-link :to="{name: 'MLogin'}" class="loginBtn" v-if="!user.isLogin">登录/注册</router-link>
            </div>
            <div class="nav">
                <div class="box course" @click="gotoMyCourse">
                    <div class="icon icon-course"></div>
                    <div class="name">课程表</div>
                </div>
                <div class="box order" @click="gotoOrder">
                    <div class="icon icon-order"></div>
                    <div class="name">订单中心</div>
                </div>
                <div class="box wallet" @click="gotoMyWallet">
                    <div class="price">{{item.callbalance}}</div>
                    <div class="name">我的钱包</div>
                </div>
            </div>
        </div>
        <div class="m-body">
            <!-- <div class="box" @click="gotoMyQuestion">
                <div class="left">
                   <div class="icon icon-question"></div>
                    <span>我的题库</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <div class="box" @click="gotoMyExam">
                <div class="left">
                   <div class="icon icon-exam"></div>
                    <span>我的考试</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div> -->
            <div class="box" @click="checkTicket">
            <div class="left">
                <div class="icon icon-ticket"></div>
                <span>我的票券</span>
            </div>
            <div class="right">
                <div class="icon icon-arrow-right"></div>
            </div>
        </div>
            <div class="box" @click="gotoMyResume">
                <div class="left">
                    <div class="icon icon-resume"></div>
                    <span>简历管理</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <!-- <div class="box" @click="gotoMyAchievement">
                <div class="left">
                    <div class="icon icon-achievement"></div>
                    <span>我的成就</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div> -->
            <div class="box" @click="gotoMyFavorite">
                <div class="left">
                    <div class="icon icon-favorite"></div>
                    <span>我的收藏</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <div class="box" @click="gotoMyFollow">
                <div class="left">
                    <div class="icon icon-follow"></div>
                    <span>我的关注</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <div class="box" @click="gotoUserInfo">
                <div class="left">
                    <div class="icon icon-user-info"></div>
                    <span>个人信息</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
        </div>
        <div class="logout" v-if="user.isLogin" @click="logout">退出登录</div>
    </div>
</template>

<script>
  import {getUserCustomerInfo} from 'api/systemApi'
  import {mapActions, mapGetters} from 'vuex'
  export default {
    name: 'me',
    props: ['kmctype'],
    data() {
      return {
        init: false,
        item: {
          callbalance: '0',
          desp:'',
          qq:'',
          headimgattid:'',
          sextext:'',
          wxno:'',
          sex:99,
          headimgurl:'',
          nickname:'',
          name:'',
          mobileno:'',
          email:''
        },
        imgHeaderImg: require('@/common/images/mmy/img-headerImg.png')
      }
    },
    mounted() {},
    activated() {
      if (this.user.isLogin && !this.init) {
        this.getView()
      }
    },
    methods: {
      checkTicket() {
        this._isLogin('myTicket')
      },
      gotoOrder() {
        this.setRefresh(true)
        this._isLogin('MOrderList')
      },
      gotoMyCourse() {
        this._isLogin('MMyCourse')
      },
      gotoMyWallet() {
        this._isLogin('MMyWallet')
      },
      gotoMyQuestion() {
        this._isLogin('MMyQuestion')
      },
      gotoMyExam() {
        this._isLogin('MMyExam')
      },
      gotoMyResume() {
        this._isLogin('MResume')
      },
      gotoMyFavorite() {
        this._isLogin('MMyFavorite')
      },
      gotoMyFollow() {
        this._isLogin('MMyFollow')
      },
      gotoUserInfo() {
        this._isLogin('UserInfo')
      },
      // gotoMyAchievement() {
      //   this._isLogin('MMyAchievement')
      // },
      _isLogin(componentName) {
        if (this.user.isLogin) {
          this.$router.push({name: componentName})
          this.setRefresh(true)
        } else {
          this.$toast.fail('请先登录')
        }
      },
      logout() {
        this.$dialog.confirm({
          title: '',
          message: '确认退出登录吗？',
          confirmButtonColor: '#409EFF'
        }).then(() => {
          this._logout()
        }).catch(() => {})
      },
      _logout() {
        let user = {
          innerid: '',
          loginToken: '',
          loginname: '',
          logourl: '',
          mobile: '',
          name: '',
          nickname: '',
          isLogin: false,
          zjmemtype: 0
        }
        this.item.callbalance = '0'
        this.setUser(user)
        sessionStorage.setItem('user', JSON.stringify(user))
      },
      getView() {
        this.setLoading(true)
        getUserCustomerInfo({
          data: {},
          success: data => {
            this.setLoading(false)
            this.init = true
            this.item = data.data
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setUser', 'setRefresh'])
    },
    filters: {},
    watch: {
    },
    computed: {
      ...mapGetters(['user'])
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .me {
        position: relative;
        padding-bottom: 0.88rem;
        .m-header{
            padding: 0.4rem 0.32rem;
            background: $c-white;
            .top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 0.28rem;
                .userInfo{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .headerImage{
                        width: 1.1rem;
                        height: 1.1rem;
                        margin-right: 0.38rem;
                        margin-left: 0.16rem;
                        .userImg{
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                    .tip{
                        color: $c-grey;
                        font-size: 0.28rem;
                    }
                    .name{
                        font-size: 0.36rem;
                        color: $c-black;
                    }
                }
                .loginBtn{
                    width: 1.4rem;
                    height: 0.48rem;
                    line-height: 0.48rem;
                    text-align: center;
                    font-size: 0.24rem;
                    color: $c-blue;
                    border: 0.02rem solid $c-blue;
                    border-radius: 0.24rem;
                }

            }
            .nav{
                display: flex;
                justify-content: space-around;
                align-items: center;
                border: 0.01rem solid $line;
                border-radius: 0.1rem;
                box-shadow:0 0.02rem 0.06rem 0 rgba(0,0,0,0.1);
                padding: 0.24rem 0;
                .box{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-direction: column;
                    width: 2rem;
                    box-sizing: border-box;
                    .icon{
                        width: 0.8rem;
                        height: 0.8rem;
                    }
                    .name{
                        color: $c-gray;
                        font-size: 0.26rem;
                        line-height: 0.36rem;
                        margin-top:0.12rem;
                    }
                    .price{
                        height: 0.8rem;
                        line-height: 0.8rem;
                        font-size: 0.42rem;
                        font-weight: 600;
                    }
                }
                .course{
                    padding-left: 0.32rem;
                }
                .order{
                    padding-right: 0.32rem;
                }
                .wallet{
                    width: 2.4rem;
                    border-left: 0.01rem solid $line;
                }
            }
        }
        .m-body{
            margin-top: 0.2rem;
            background: $c-white;
            padding: 0 0.32rem;
            color: $c-black;
            font-size: 0.3rem;
            .box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 1.1rem;
                box-sizing: border-box;
                .left{
                    display: flex;
                    align-items: center;
                    .icon{
                        width: 0.36rem;
                        height: 0.36rem;
                        margin-right: 0.1rem;
                    }
                }
                .right{
                    .icon{
                        width: 0.15rem;
                        height: 0.25rem;
                    }
                }

            }
            .box+.box{
                border-top: 0.01rem solid $line;
            }
        }
        .logout{
            margin-top: 0.48rem;
            height: 1.1rem;
            font-size: 0.3rem;
            color: $c-red;
            line-height: 1.1rem;
            text-align: center;
            background: $c-white;
        }
    }
</style>